export const APPLICATION_STATUS_MODAL_SUBTITLE_WITH_PHONE = 'Партнёр Циана позвонит на';
export const APPLICATION_STATUS_MODAL_SUBTITLE_WITHOUT_PHONE = 'Партнёр Циана скоро позвонит';
export const APPLICATION_STATUS_MODAL_WARNING = 'Отменить или перенести заявку можно через поддержку';
